module.exports = __webpack_public_path__ + "static/media/app-store.0e8d88c0.svg";